import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    const isChunkLoadError =
      error instanceof Error &&
      (error.name === 'ChunkLoadError' ||
        error.message?.includes('Loading chunk') ||
        error.message?.includes('Failed to fetch dynamically imported module') ||
        error.message?.includes('Importing a module script failed'));

    if (isChunkLoadError) {
      window.location.reload();
      return;
    }

    console.error(error);
  }
}
